import { Component } from '@angular/core';

@Component({
  selector: 'app-custom-fields-skeleton',
  standalone: true,
  templateUrl: './custom-fields-skeleton.component.html',
  styleUrl: './custom-fields-skeleton.component.scss'
})
export class CustomFieldsSkeletonComponent {
  readonly numberOfRows = new Array(4);
  readonly numberOfCols = new Array(3);
}
